var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCilSmoke(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 230,
    height: 230,
    viewBox: "0 0 230 230",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.15,
    clipPath: "url(#clip0_179_14358)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.1719 70.8242L29.4844 104.924L127.237 161.361L146.924 127.262L49.1719 70.8242ZM123.394 147.018L43.8276 101.081L53.0151 85.1675L132.581 131.105L123.394 147.018ZM153.744 131.199L162.838 136.449L143.15 170.549L134.057 165.299L153.744 131.199ZM169.658 140.387L178.751 145.637L159.063 179.736L149.97 174.486L169.658 140.387ZM165.093 112.48C164.953 110.206 165.556 107.948 166.812 106.047C168.068 104.146 169.908 102.706 172.055 101.943C176.478 100.393 180.253 97.4031 182.773 93.4518C185.293 89.5005 186.414 84.8173 185.954 80.1532L185.636 76.8656L175.242 70.8646L174.511 70.9355L175.503 81.1659C175.733 83.4932 175.174 85.8301 173.916 87.8017C172.658 89.7734 170.775 91.2655 168.568 92.0388C164.266 93.5671 160.577 96.4539 158.06 100.263C155.543 104.073 154.334 108.598 154.615 113.155L154.842 116.678L165.771 122.988L165.093 112.48ZM185.553 124.292C185.412 122.018 186.016 119.76 187.272 117.86C188.528 115.959 190.368 114.518 192.515 113.756C196.938 112.206 200.713 109.216 203.233 105.264C205.753 101.313 206.873 96.6298 206.414 91.9657L206.096 88.6781L195.702 82.6771L194.971 82.748L195.963 92.9784C196.192 95.3057 195.633 97.6426 194.376 99.6142C193.118 101.586 191.235 103.078 189.028 103.851C184.725 105.38 181.037 108.266 178.52 112.076C176.003 115.885 174.794 120.41 175.075 124.967L175.302 128.49L186.231 134.8L185.553 124.292Z",
    fill: "#E69A8D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_179_14358"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 168,
    height: 168,
    fill: "white",
    transform: "translate(84) rotate(30)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCilSmoke);
export default __webpack_public_path__ + "static/media/cil_smoke.356b9a734acfacb73052ef546976028e.svg";
export { ForwardRef as ReactComponent };